<template>
	<svg
		width="20"
		height="20"
		viewBox="0 0 20 20"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clip-path="url(#clip0_1297_7323)">
			<path
				d="M2.5 17.5H17.5V15.8333H2.5V17.5ZM2.5 6.66667V13.3333L5.83333 10L2.5 6.66667ZM9.16667 14.1667H17.5V12.5H9.16667V14.1667ZM2.5 2.5V4.16667H17.5V2.5H2.5ZM9.16667 7.5H17.5V5.83333H9.16667V7.5ZM9.16667 10.8333H17.5V9.16667H9.16667V10.8333Z"
				fill="#444C58"
			/>
		</g>
		<defs>
			<clipPath id="clip0_1297_7323">
				<rect
					width="20"
					height="20"
					fill="white"
				/>
			</clipPath>
		</defs>
	</svg>
</template>

